import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';

export const MODAL_ACTION_CONFIRM = 'confirm';
export const MODAL_ACTION_CANCEL = 'cancel';

type ModalAction = typeof MODAL_ACTION_CONFIRM | typeof MODAL_ACTION_CANCEL | null;

@Component({
  selector: 'pf-modal',
  imports: [NgClass],
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalComponent implements AfterViewInit{
  @Input() name!: string;
  @Input() title!: string;
  @Input() body!: string;
  @Input() cancelButtonText!: string;
  @Input() confirmButtonText: string = 'OK';
  @Input() hasCrossButton = true;
  @Input() hasConfirmButton = true;
  @Input() isSmallVariant = true;
  @Input() iconClass = 'ba-icon-info';
  @Input() modalId!: string;


  @Output() cancelled = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<boolean>();


  @ViewChild('modalDialog') modalDialog!: ElementRef<HTMLDivElement>;
  @ViewChild('confirmButton') confirmButton!: ElementRef<HTMLButtonElement>;


  private pendingAction: ModalAction = null;


  ngAfterViewInit() {
    const el = this.modalDialog.nativeElement;


    el.addEventListener('shown.bs.modal', () => {
      this.pendingAction = null; // Reset für nächste Öffnung
      if (this.hasConfirmButton) {
        this.confirmButton?.nativeElement?.focus();
      }
    });


    // feuert cancelled event, wenn ausserhalb geklickt wurde
    el.addEventListener('hide.bs.modal', (event: any) => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      if (!event.relatedTarget && this.pendingAction === null) {
        this.cancelled.emit(true);
      }
    });


    // feuert cancelled, confirmed event erst, wenn modal geschlossen wurde
    el.addEventListener('hidden.bs.modal', () => {
      if (this.pendingAction === MODAL_ACTION_CONFIRM) {
        this.confirmed.emit(true);
      }
      if (this.pendingAction === MODAL_ACTION_CANCEL) {
        this.cancelled.emit(true);
      }
      this.pendingAction = null;
    });
  }

  open(options: any = {}) {
    const Modal = globalThis.dpl.bs.Modal;
    const modal = Modal.getInstance(this.modalDialog.nativeElement) || new Modal(this.modalDialog.nativeElement, options);
    modal.toggle();
  }


  onConfirmClicked() {
    this.pendingAction = MODAL_ACTION_CONFIRM; // modal wird geschlossen via data-bs-dismiss, dann erst wird event confirmed emittiert
  }


  onCancelClicked() {
    this.pendingAction = MODAL_ACTION_CANCEL; // modal wird geschlossen via data-bs-dismiss, dann erst wird event cancelled emittiert
  }

    onCloseClicked() {
        this.pendingAction = this.cancelButtonText  ? MODAL_ACTION_CANCEL : MODAL_ACTION_CONFIRM;
    }


  showHeadlineIcon() {
    return this.iconClass ? ['ba-icon', this.iconClass] : [];
  }
}